import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function MetricCard({ label, value, icon: Icon, helper, tone = "default", testId, to, highlight, className }) {
  const accent = tone === "accent";
  const danger = tone === "danger";

  const card = (
    <Card
      className={cn(
        "p-5 border-border",
        accent && "border-accent/30",
        danger && "border-rose-300 ring-1 ring-rose-200 dark:ring-rose-900",
        highlight && "border-primary ring-1 ring-primary/20",
        className,
      )}
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">{label}</div>
        {Icon && <Icon className={`h-4 w-4 ${accent ? "text-accent" : danger ? "text-rose-500" : "text-muted-foreground"}`} aria-hidden="true" />}
      </div>
      <div className={`mt-3 font-display text-2xl font-bold tracking-tight ${accent ? "text-accent" : danger ? "text-rose-600 dark:text-rose-400" : ""}`}>
        {value}
      </div>
      {helper && <div className="mt-2 text-xs text-muted-foreground">{helper}</div>}
    </Card>
  );

  return to ? <Link to={to}>{card}</Link> : card;
}
